import _ from 'lodash';
import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import {useLayer} from 'react-laag';

import toast from 'react-hot-toast';
import styled from 'styled-components';
import {InternalNavLink} from '../../../../ui-toolkit/elements/button/btn-type/InternalNavLink';
import {Icon} from '../../Icon/Icon';
import {Btn} from '../btn-type/Btn';
import {ConfirmButtonTooltip} from './ConfirmButtonTooltip';

function ConfirmButton({
    t,
    color,
    onClick,
    to,
    confirmTxt,
    cancelTxt,
    confirmToolTipTitle,
    confirmToolTipBody,
    children,
    ...rest
}) {
    let [clicked, setClicked] = useState(false);

    const {triggerProps, layerProps, renderLayer} = useLayer({
        isOpen: clicked,
        placement: 'bottom-center',
        auto: true,
        onOutsideClick: () => setClicked(false),
        triggerOffset: 8,
    });

    const doClick = () => {
        const clickRes = Promise.resolve(onClick());

        return clickRes
            .catch((e) => {
                if (typeof e == 'string') toast.error(e);
                else toast.error(_.get(e, 'message', t('errors.general')));
            })
            .finally(() => setClicked(false));
    };

    return (
        <>
            <Btn color={color} {...rest} type="button" onClick={() => setClicked(!clicked)} {...triggerProps}>
                {children}
            </Btn>
            {clicked &&
                renderLayer(
                    <ConfirmButtonTooltip
                        color={color}
                        title={confirmToolTipTitle ?? t('confirmButton.title')}
                        {...layerProps}>
                        <BodyWrapper>{confirmToolTipBody}</BodyWrapper>
                        {onClick && (
                            <Btn onClick={doClick} type="button">
                                <Icon name="thumbUp" />
                                {confirmTxt ?? t('confirmButton.yes')}
                            </Btn>
                        )}
                        {to && (
                            <InternalNavLink to={to}>
                                <Icon name="thumbUp" />
                                {confirmTxt ?? t('confirmButton.yes')}
                            </InternalNavLink>
                        )}
                        <Btn link onClick={() => setClicked(false)} type="button">
                            <Icon name="thumbDown" />
                            {cancelTxt ?? t('confirmButton.no')}
                        </Btn>
                    </ConfirmButtonTooltip>,
                )}
        </>
    );
}

export default withTranslation()(ConfirmButton);

const BodyWrapper = styled.div`
    width: 500px;
    color: var(--white-00);
    margin-bottom: var(--space-sm);
`;
